<banner-notification *ngIf="interdictionEndDate | countDown | async" [showIcon]="true"
  [alertLevel]="notificationAlertLevel.Lead">
  <span
    message>{{interdictionEndDate | countDown | async | humanizeDate:humanizeConfig | bannerNotificationInterdictionMessage}}</span>
</banner-notification>
